import { DAYS_EXPIRED_COOKIE } from "constants/common.constants";
import Cookies from "cookies-ts";
import moment from "moment";

const cookies = new Cookies();

const get = (key: string) => {
  return cookies.get(key);
};

const remove = (key: string) => {
  return cookies.remove(key);
};

const set = (key: string, value: any, days?: number) => {
  const expires = moment()
    .add(days ? days : DAYS_EXPIRED_COOKIE, "days")
    .toDate();
  return cookies.set(key, value, { expires: expires });
};

export const cookiesStorage = {
  get,
  set,
  remove,
};
